var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDialect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.88136,
    y: 234.30508,
    width: 724.61017,
    height: 624.81356,
    id: "rect222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g29516",
    style: {
      strokeWidth: 30,
      strokeDasharray: "none"
    },
    transform: "matrix(0.99848231,0,0,1.1022552,0.77594069,-51.106252)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      overflow: "hidden",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 160.04473,956.56056 703.44951,-0.1494 V 520.39982 c -67.99925,0.43534 -585.36733,0.53842 -703.30732,1.00754 l -2.14739,143.06794 -132.083045,66.03543 132.047945,82.5435 z",
    id: "path751-2-3"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "520.54px",
      lineHeight: 1.25,
      fontFamily: "Candara",
      InkscapeFontSpecification: "'Candara, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      overflow: "hidden",
      fill: "#4d4d4d",
      strokeWidth: 31.152,
      strokeDasharray: "none"
    },
    x: 181.72581,
    y: 916.20007,
    id: "text1786",
    transform: "scale(1.0433425,0.95845805)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1784",
    x: 181.72581,
    y: 916.20007,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "520.54px",
      fontFamily: "Arial",
      fill: "#4d4d4d",
      strokeWidth: 31.152,
      strokeDasharray: "none"
    }
  }, "\u0259\u028A"))), /*#__PURE__*/React.createElement("g", {
    id: "g29510",
    transform: "matrix(0.99848231,0,0,1.1022552,0.77594069,-73.151356)",
    style: {
      strokeWidth: 30,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      overflow: "hidden",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 862.48643,519.36402 -703.4495,-0.1494 V 83.203276 c 67.9992,0.43534 585.36732,0.53842 703.30731,1.00754 l 2.14739,143.067944 132.08305,66.03543 -132.04795,82.5435 z",
    id: "path751-2-3-8"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "509.574px",
      lineHeight: 1.25,
      fontFamily: "Candara",
      InkscapeFontSpecification: "'Candara, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      overflow: "hidden",
      fill: "#4d4d4d",
      strokeWidth: 30.8941,
      strokeDasharray: "none"
    },
    x: 186.75516,
    y: 472.99646,
    id: "text1786-8",
    transform: "scale(1.0504258,0.95199489)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1784-3",
    x: 186.75516,
    y: 472.99646,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "509.574px",
      fontFamily: "Arial",
      fill: "#4d4d4d",
      strokeWidth: 30.8941,
      strokeDasharray: "none"
    }
  }, "o\u028A"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialect);
export default __webpack_public_path__ + "static/media/dialect.98d3296237673b2df73fe6d11cfb9e27.svg";
export { ForwardRef as ReactComponent };